import { Media } from "./media";
import { QuizAnswer } from './quiz-answer';
import { DatabaseModel } from './database-model';
import { MediaType } from './media-file';

export enum QuizAnswerMethod {
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    TEXT_INPUT = "TEXT_INPUT"
}

export class QuizQuestion extends DatabaseModel {
    // Unique identifier for question
    public key: string = '';
    // Quiz question
    public question: string = '';
    // Quiz question description
    public description: string = '';
    // Illustration of question
    public media: Media = null;
    // List of possible answers
    public answers: QuizAnswer[] = [];
    // Answer type (show multiple choice or free text input as answer method)
    public answerMethod: QuizAnswerMethod = QuizAnswerMethod.MULTIPLE_CHOICE;
    // Challenge key reference that the question belongs to
    public challenge: string = '';
    // Enable/disable a question to include/exclude it in a challenge
    public disabled: boolean = true;

    constructor(json: any = null, key: string = "") {
        super();
        this.fromJson(json);
        this.key = key || json?.key || this.genKey();
    }

    public toJson() {
        return {
            key: this.key,
            question: this.question,
            media: this.media ? this.media.toJson() : null,
            answers: this.answers ? this.answers.map(answer => answer.toJson()) : [],
            challenge: this.challenge,
            answerMethod: this.answerMethod,
            description: this.description,
            disabled: Boolean(this.disabled)
        }
    }

    public fromJson(json: any) {
        if(!json) return;

        this.key = json.key;
        this.question = json.question || "";
        this.media = json.media ? new Media(json.media, json.media.key) : this.getDefaultMedia();
        // Check if firebase is getting this out as an array (client side)
        if(json.answers?.map) this.answers = json.answers.map(json => new QuizAnswer(json, json.key));
        // Or the array is a map (server side)
        else this.answers = Object.keys(json.answers || {}).map(idx => new QuizAnswer(json.answers[idx], json.answers[idx]?.key));

        this.challenge = json.challenge || "";
        this.answerMethod = json.answerMethod || QuizAnswerMethod.MULTIPLE_CHOICE;
        this.description = json.description || "";
        this.disabled = Boolean(json.disabled);
    }

    private getDefaultMedia(): Media {
        let media = new Media();
        media.hd.url = "https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements_webp%2FQuiz-answer.webp?alt=media&token=02086a7e-fde7-42eb-af18-56340f792fde";
        media.hd.fallback = "https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements%2FQuiz-answer.png?alt=media&token=e616ed5e-d2f9-4729-823c-e54f0d48a2d5";
        media.thumb.url = "https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements_webp%2FQuiz-answer-thumb.webp?alt=media&token=1cf4994a-ba01-46a8-b264-bbfa1567fdf6";
        media.thumb.fallback = "https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Ffloating-elements%2FQuiz-answer-thumb.png?alt=media&token=93a589f9-0886-4a53-83d0-ed49157fadea";
        media.type = MediaType.IMAGE;
        media.title = "Animated person looking thoughtful next to a question mark.";
        return media;
    }
}
